/* ============================================================
   Snus2go theme - interaction layer
   Vanilla JS. Handles:
     - mobile menu toggle
     - age gate (30-day cookie)
     - cart drawer + AJAX add-to-cart + line qty + remove + the sale upsell
     - strength meter scrub + tier click → filter URL
     - subscribe builder math
     - PDP variant + qty
     - collection filter form auto-submit
     - last-minute sale countdowns
   ============================================================ */
(function(){
  'use strict';

  const $  = (s, ctx) => (ctx || document).querySelector(s);
  const $$ = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  const money = (cents) => {
    if (cents == null) return '';
    const dollars = (cents / 100);
    return '$' + dollars.toFixed(2);
  };

  /* ------------ Mobile menu ------------ */
  const sheet = $('[data-mobile-sheet]');
  if (sheet) {
    const open  = $('[data-mobile-open]');
    const close = $('[data-mobile-close]');
    const stop  = $('[data-mobile-stop]');
    const toggle = (val) => {
      sheet.classList.toggle('is-open', val);
      document.body.style.overflow = val ? 'hidden' : '';
    };
    open && open.addEventListener('click', () => toggle(true));
    close && close.addEventListener('click', () => toggle(false));
    sheet.addEventListener('click', () => toggle(false));
    stop && stop.addEventListener('click', (e) => e.stopPropagation());
  }

  /* ------------ Age gate ------------ */
  const ageGate = $('[data-age-gate]');
  if (ageGate) {
    const AGE_COOKIE = 'snus2go_age_ok';
    // Remember the answer across visits (not just the tab session) so the gate
    // only shows once. 30-day expiry matches the notice in the dialog.
    const ageVerified = () => document.cookie.split('; ').indexOf(AGE_COOKIE + '=1') !== -1;
    const rememberAge = () => {
      document.cookie = AGE_COOKIE + '=1; path=/; max-age=' + (30 * 24 * 60 * 60) + '; SameSite=Lax';
    };
    const isBot  = /bot|crawl|spider|slurp|googlebot|bingbot|duckduckbot|yandex|facebookexternalhit|twitterbot|google-inspectiontool|googleother|lighthouse|pagespeed|headless/i.test(navigator.userAgent);
    // layout/theme.liquid runs the same cookie and UA tests inline in <head>
    // and sets html.age-ok before first paint, so a returning visitor or a
    // crawler never sees the gate flash. Keep that regex and this one the same.
    // When the class is already on <html> the scrim is hidden by CSS, so the
    // page must not be locked behind overflow:hidden.
    const preOk  = document.documentElement.classList.contains('age-ok');
    if (ageVerified() || isBot || preOk) {
      ageGate.classList.add('is-closed');
    } else {
      document.documentElement.style.overflow = 'hidden';
      const monthSel = $('[data-age-month]', ageGate);
      const daySel   = $('[data-age-day]', ageGate);
      const yearSel  = $('[data-age-year]', ageGate);
      const yesBtn   = $('[data-age-yes]', ageGate);
      const noBtn    = $('[data-age-no]', ageGate);
      const minAge   = parseInt(ageGate.dataset.minAge || '21', 10);

      const recheck = () => {
        const y = parseInt(yearSel.value || '0', 10);
        const m = parseInt(monthSel.value || '0', 10);
        const d = parseInt(daySel.value || '0', 10);
        if (!y || !m || !d) { yesBtn.disabled = true; return; }
        const dob = new Date(y, m - 1, d);
        const cutoff = new Date();
        cutoff.setFullYear(cutoff.getFullYear() - minAge);
        yesBtn.disabled = !(dob <= cutoff);
      };
      [monthSel, daySel, yearSel].forEach(sel => sel && sel.addEventListener('change', recheck));

      yesBtn && yesBtn.addEventListener('click', () => {
        rememberAge();
        ageGate.classList.add('is-closed');
        document.documentElement.classList.add('age-ok');
        document.documentElement.style.overflow = '';
      });
      noBtn && noBtn.addEventListener('click', () => {
        window.location.replace('https://www.google.com');
      });
    }
  }

  /* ------------ Newsletter: one-time confirmation ------------ */
  /* Shopify answers the customer form by reloading the page with
     ?customer_posted=true (plus the action's #contact_form anchor), and
     sections/newsletter.liquid shows "You're in" for as long as that param is
     in the URL. Drop it once the message has rendered, so a reload, the back
     button or a copied link brings up a fresh form, and bring the whole
     section into view rather than the bare form the anchor lands on. */
  const newsPosted = $('[data-news-posted]');
  if (newsPosted) {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('customer_posted')) {
        url.searchParams.delete('customer_posted');
        window.history.replaceState(null, '', url.pathname + url.search);
      }
    } catch (e) { /* no URL API: leave the address bar alone */ }
    const newsSection = newsPosted.closest('.news');
    const showNews = () => newsSection && newsSection.scrollIntoView({ block: 'start' });
    if (document.readyState === 'complete') showNews();
    else window.addEventListener('load', showNews, { once: true });
  }

  /* ------------ Cart drawer ------------ */
  const drawer       = $('#CartDrawer');
  const scrim        = $('[data-cart-scrim]');
  const countDisplay = $$('[data-cart-count]');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim && scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  };

  $$('[data-cart-open]').forEach(b => b.addEventListener('click', openDrawer));
  // Close is delegated on document: the button lives inside #CartDrawer, whose
  // innerHTML is replaced on every add/qty change (applyDrawerHtml), which would
  // wipe a directly-bound listener. Delegation survives those swaps.
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  scrim && scrim.addEventListener('click', closeDrawer);
  // "Pick from the deals" in the held-Checkout note scrolls the bag to the
  // deal cans (snippets/sale-upsell.liquid; the full-price row sits above
  // them) instead of leaving for the Sale page; "Pick your free can" in the
  // Buy 1 Get 1 note (data-upsell-jump="pair") scrolls to the full-price row.
  // Delegated: the drawer's markup is swapped on every change.
  document.addEventListener('click', (e) => {
    const jump = e.target.closest('[data-upsell-jump]');
    if (!jump) return;
    const scope = jump.closest('#CartDrawer') || document;
    const row = jump.dataset.upsellJump === 'pair' ? '[data-cart-pair]' : '[data-cart-deals]';
    const strip = scope.querySelector(row) || scope.querySelector('[data-cart-upsell]');
    if (!strip) return;
    e.preventDefault();
    strip.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  const SECTION_ID = 'cart-drawer-snippet';

  const setCartCount = (count) => {
    const n = Math.max(0, count);
    countDisplay.forEach(el => el.textContent = String(n));
    $$('[data-cart-count-display]').forEach(el => el.textContent = `${n} ${n === 1 ? 'item' : 'items'}`);
  };

  /* Swap in freshly rendered drawer markup - either from the Section
     Rendering API or from the `sections` bundle that /cart/add.js and
     /cart/change.js return - and sync the header count from it. Keeps a
     cart update to a single round trip instead of follow-up fetches.
     onCount, when given, receives the count instead of setCartCount: the
     quick add ticks it when its dot lands on the bag pill. */
  const applyDrawerHtml = (html, onCount) => {
    if (!html || !drawer) return false;
    const newDrawer = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
    if (!newDrawer) return false;
    drawer.innerHTML = newDrawer.innerHTML;
    bindDrawerLineButtons();
    const countEl = newDrawer.querySelector('[data-cart-count-display]');
    const digits = countEl && countEl.textContent.match(/\d+/);
    if (digits) (onCount || setCartCount)(parseInt(digits[0], 10));
    return true;
  };

  const refreshDrawer = async (onCount) => {
    try {
      const res = await fetch('?section_id=' + SECTION_ID, { headers: { 'Accept': 'text/html' } });
      if (!res.ok) throw new Error('no section endpoint');
      if (!applyDrawerHtml(await res.text(), onCount)) throw new Error('drawer missing from section payload');
    } catch (e) {
      // Fallback to cart.js
      const cart = await fetch(window.theme.routes.cart_url + '.js').then(r => r.json());
      const lines = $('[data-cart-lines]');
      const subEls = $$('[data-cart-subtotal]');
      if (lines && cart) {
        // The offer rows are Liquid-rendered; keep the ones on screen, but
        // not the full-price row or the Buy 1 Get 1 note: their "Free" was
        // worked out for the bag before this change, and they come back on
        // the next drawer render.
        const upsell = lines.querySelector('[data-cart-upsell]');
        const pairRow = upsell && upsell.querySelector('[data-cart-pair]');
        if (pairRow) pairRow.remove();
        $$('.drawer__nudge', drawer).forEach(el => el.remove());
        if (cart.item_count === 0) {
          lines.innerHTML = '<div style="padding:56px 0;text-align:center;"><p style="font-size:14px;color:var(--subtext);">Your bag is empty.</p></div>';
        } else {
          // One row per can, as the Liquid drawer draws them
          // (snippets/bag-line-key.liquid): the lines of one variant, selling
          // plan and visible properties, their quantities and prices summed.
          const rows = [];
          const rowByKey = {};
          cart.items.forEach(item => {
            const props = Object.keys(item.properties || {}).filter(k => k[0] !== '_').sort().map(k => `${k}=${item.properties[k]}`).join(';');
            const spa = item.selling_plan_allocation;
            const plan = spa && spa.selling_plan ? spa.selling_plan.id : '';
            const rk = `${item.variant_id}|${plan}|${props}`;
            let row = rowByKey[rk];
            if (!row) {
              row = rowByKey[rk] = { head: item, keys: [], quantity: 0, original_line_price: 0, final_line_price: 0 };
              rows.push(row);
            }
            row.keys.push(item.key);
            row.quantity += item.quantity;
            row.original_line_price += item.original_line_price;
            row.final_line_price += item.final_line_price;
          });
          lines.innerHTML = rows.map(row => {
            const item = row.head;
            const spa = item.selling_plan_allocation;
            const saved = row.original_line_price - row.final_line_price;
            const discounted = saved > 0;
            // Subscription savings are baked into the line price (no discount
            // application), so surface them from the allocation instead.
            const subSaving = spa && spa.compare_at_price > spa.price;
            const subWas = subSaving ? spa.compare_at_price * row.quantity : null;
            const subPct = subSaving ? Math.round((spa.compare_at_price - spa.price) * 100 / spa.compare_at_price) : 0;
            let bogo = '';
            const bogoCfg = window.theme && window.theme.bogo;
            if (bogoCfg && bogoCfg.active && discounted && item.original_price > 0) {
              // Whole units: the Buy X Get Y discounts take 100% off the free
              // unit, on the line it sits on (bogo-line-note.liquid).
              const freePacks = Math.round(saved / item.original_price);
              // Pack size from the "N-pack" option only — a strength like "10mg"
              // or "1.5mg" in the title must never read as a pack size. Mirrors
              // bogo-line-note.liquid.
              const packMatch = (item.variant_title || '').match(/(\d+)\s*-\s*pack/i);
              const pack = packMatch ? parseInt(packMatch[1], 10) : 1;
              const freeCans = freePacks * pack;
              if (freeCans > 0) {
                bogo = `<div class="line__bogo">${freeCans} free can${freeCans === 1 ? '' : 's'}</div>`;
              }
            }
            return `
            <div class="line" data-line-key="${item.key}" data-line-keys="${row.keys.join(',')}" data-line-head-qty="${item.quantity}">
              <a href="${item.url}" class="line__media">${item.image ? `<img src="${item.image}" alt="" width="80" height="80">` : ''}</a>
              <div>
                <a href="${item.url}" class="line__title">${(item.product_title || '').replace(' Nicotine Pouches', '')}</a>
                <div class="line__variant">${item.variant_title || ''}</div>
                ${spa ? `<span class="line__sub">${spa.selling_plan.name}${subPct > 0 ? ', ' + subPct + '% off' : ''}</span>` : ''}
                ${bogo}
                <div class="line__row">
                  <div class="line__qty">
                    <button type="button" data-qty-down data-line-key="${item.key}">−</button>
                    <span>${row.quantity}</span>
                    <button type="button" data-qty-up data-line-key="${item.key}">+</button>
                  </div>
                  <div class="line__price">${discounted ? `<s>${money(row.original_line_price)}</s> ` : (subWas ? `<s>${money(subWas)}</s> ` : '')}${money(row.final_line_price)}</div>
                </div>
                <button type="button" class="line__remove" data-line-remove data-line-key="${item.key}">Remove</button>
              </div>
            </div>`;
          }).join('');
          if (upsell) lines.appendChild(upsell);
        }
      }
      subEls.forEach(el => el.textContent = money(cart.total_price));
      // Keep the footer in sync - without this the checkout button stays
      // disabled and the free-shipping progress stays stuck at its empty-cart
      // state after an AJAX add. (Mirrors the logic in cart-drawer.liquid.)
      const shipCfg = (window.theme && window.theme.shipping) || {};
      const threshold = parseInt(shipCfg.thresholdCents, 10) || 0;
      const progressText = $('[data-cart-progress-text]', drawer);
      const progressBar  = $('.progress', drawer);
      if (threshold > 0) {
        const remaining = Math.max(0, threshold - cart.total_price);
        if (progressText) {
          progressText.innerHTML = remaining > 0
            ? `Flat ${money(shipCfg.flatCents)} shipping. <strong>${money(remaining)}</strong> more for free shipping.`
            : '<strong>This order ships free.</strong>';
        }
        if (progressBar) {
          progressBar.style.setProperty('--p', Math.min(100, cart.total_price * 100 / threshold) + '%');
        }
      }
      const checkoutBtn = $('button[name="checkout"]', drawer);
      if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;
      (onCount || setCartCount)(cart.item_count);
      bindDrawerLineButtons();
    }
  };

  const changeLine = async (id, quantity) => {
    // Bundle the re-rendered drawer into the same response (`sections`) so a
    // quantity change costs one request, not a change + two refetches.
    const res = await fetch(window.theme.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity, sections: SECTION_ID })
    });
    const cart = await res.json().catch(() => null);
    if (cart && cart.sections && applyDrawerHtml(cart.sections[SECTION_ID])) {
      if (cart.item_count != null) setCartCount(cart.item_count);
      return;
    }
    await refreshDrawer();
  };

  /* Several lines at once: /cart/update.js takes line keys (as strings) and,
     like change.js, bundles the re-rendered drawer into its response. */
  const updateLines = async (updates) => {
    const res = await fetch(window.theme.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, sections: SECTION_ID })
    });
    const cart = await res.json().catch(() => null);
    if (cart && cart.sections && applyDrawerHtml(cart.sections[SECTION_ID])) {
      if (cart.item_count != null) setCartCount(cart.item_count);
      return;
    }
    await refreshDrawer();
  };

  /* A bag row can join several cart lines of one variant: Shopify puts the
     free can of a Buy 1 Get 1 pair on its own line (snippets/bag-line-key.liquid
     says which lines share a row). The row prints the lines' total in its
     span and carries data-line-keys (every line) and data-line-head-qty (the
     first line's own quantity): the steppers move that first line by 1, and
     Remove clears every line of the row. */
  const headQty = (row, span) => {
    const head = parseInt(row && row.dataset.lineHeadQty, 10);
    return Number.isFinite(head) ? head : parseInt((span && span.textContent) || '1', 10);
  };
  const rowKeys = (el) => {
    const row = el.closest('[data-line-keys]');
    const keys = ((row && row.dataset.lineKeys) || '').split(',').filter(Boolean);
    return keys.length ? keys : [el.dataset.lineKey];
  };
  const removeRow = async (el) => {
    const keys = rowKeys(el);
    if (keys.length === 1) return changeLine(keys[0], 0);
    const updates = {};
    keys.forEach(k => { updates[k] = 0; });
    await updateLines(updates);
  };

  /* The steppers move 1 can at a time. Buy 1 Get 1 is mix and match since
     2026-10-25: the shopper picks every can, and the automatic Buy X Get Y
     discounts in admin make the cheaper of each pair of the same pack size
     free, on whichever line it sits. */
  const bindDrawerLineButtons = () => {
    $$('[data-qty-up]', drawer).forEach(b => b.onclick = async () => {
      const span = b.parentElement.querySelector('span');
      await changeLine(b.dataset.lineKey, headQty(b.closest('[data-line-key]'), span) + 1);
    });
    $$('[data-qty-down]', drawer).forEach(b => b.onclick = async () => {
      const span = b.parentElement.querySelector('span');
      await changeLine(b.dataset.lineKey, Math.max(0, headQty(b.closest('[data-line-key]'), span) - 1));
    });
    $$('[data-line-remove]', drawer).forEach(b => b.onclick = async (e) => {
      e.preventDefault();
      await removeRow(b);
    });
  };
  if (drawer) bindDrawerLineButtons();

  /* ------------ AJAX add-to-cart ------------ */
  const isQuickAdd = (form) => form.classList.contains('chip__addform') || form.classList.contains('chart__addform');

  const reducedMotion = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* Quick add: a lime dot flies from the button to the bag pill, and the pill
     pulses when it lands (not before, as it did). onLand runs at that moment
     too, so the bag count can tick with the pulse. PING_MS matches the
     .cart-ping animation in the stylesheet. No dot under reduced motion, or
     when the pill is not on screen: the pulse and onLand run at once. */
  const PING_MS = 520;
  const flyToCart = (sourceEl, onLand) => {
    const bagPill = document.querySelector('.bag-pill');
    const land = () => {
      if (bagPill) {
        // Restart the pulse when adds come fast: drop the class, reflow, re-add.
        clearTimeout(bagPill._pingTimer);
        bagPill.classList.remove('is-pinged');
        void bagPill.offsetWidth;
        bagPill.classList.add('is-pinged');
        bagPill._pingTimer = setTimeout(() => bagPill.classList.remove('is-pinged'), 700);
      }
      if (onLand) onLand();
    };
    const start = sourceEl && sourceEl.getBoundingClientRect();
    const end = bagPill && bagPill.getBoundingClientRect();
    if (!start || !end || !start.width || !end.width || reducedMotion()) { land(); return; }
    const dot = document.createElement('div');
    dot.className = 'cart-ping';
    dot.style.left = (start.left + start.width / 2) + 'px';
    dot.style.top  = (start.top  + start.height / 2) + 'px';
    dot.style.setProperty('--tx', (end.left + end.width / 2 - start.left - start.width / 2) + 'px');
    dot.style.setProperty('--ty', (end.top  + end.height / 2 - start.top  - start.height / 2) + 'px');
    document.body.appendChild(dot);
    setTimeout(() => { dot.remove(); land(); }, PING_MS);
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.ajax-add');
    if (!form) return;
    e.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    // A button that carries both labels in its markup (the chart's "Add +"
    // and "Added", stacked so the pill keeps its width) flips a class and
    // the labels' aria-hidden; any other button swaps its text.
    const addLabel  = button && button.querySelector('[data-add-label]');
    const doneLabel = button && button.querySelector('[data-added-label]');
    const stacked   = !!(addLabel && doneLabel);
    // Markup, not text: the product page button holds the live total in a
    // span (data-pdp-cta-price), and the page retotals it once it is back.
    const originalHTML = button ? button.innerHTML : '';
    const showAdded = () => {
      if (!button) return;
      if (stacked) {
        addLabel.setAttribute('aria-hidden', 'true');
        doneLabel.removeAttribute('aria-hidden');
      } else {
        button.textContent = form.classList.contains('chip__addform') ? '✓' : 'Added';
      }
      button.classList.add('is-added');
    };
    const restore = () => {
      if (!button) return;
      button.classList.remove('is-added');
      if (stacked && button.contains(addLabel)) {
        // The spans are still there: the class change cross-fades them back.
        addLabel.removeAttribute('aria-hidden');
        doneLabel.setAttribute('aria-hidden', 'true');
      } else {
        button.innerHTML = originalHTML;
      }
      form.dispatchEvent(new CustomEvent('ajax-add:restored'));
    };
    const quickAdd = isQuickAdd(form);
    // The tap answers at once (is-busy: pressed in and dimmed, see the
    // stylesheet) instead of sitting still until Shopify answers.
    if (button) { button.disabled = true; button.classList.add('is-busy'); }

    try {
      // The quantity picked is the quantity added: no free can is added for
      // the shopper (Buy 1 Get 1 is mix and match, see bindDrawerLineButtons).
      const formData = new FormData(form);
      // Ask Shopify to bundle the re-rendered drawer into the add response -
      // one round trip covers the add, the drawer markup, and the bag count.
      formData.append('sections', SECTION_ID);
      const res = await fetch(window.theme.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Add to cart failed');
      }
      const added = await res.json().catch(() => null);
      // An add from the cart page's upsell: the page's lines and summary are
      // server-rendered, so reload them, as the page's steppers do.
      if (form.hasAttribute('data-add-reload')) {
        showAdded();
        window.location.reload();
        return;
      }
      showAdded();
      if (button) setTimeout(restore, 900);
      // Refresh the drawer silently so it shows the new items when opened.
      // Prefer the bundled section markup from the add response; refetch
      // only if it is missing.
      const drawerHtml = added && added.sections && added.sections[SECTION_ID];
      const syncDrawer = async (onCount) => {
        if (!applyDrawerHtml(drawerHtml, onCount)) await refreshDrawer(onCount);
      };
      if (quickAdd) {
        // The label flips and the dot takes off on this frame; the drawer's
        // markup swap (heavier, and off screen) waits a frame or two so the
        // first frames of the flight are not dropped. The bag count ticks
        // when the dot lands, together with the pill's pulse.
        let landed = false, count = null;
        const tick = () => { if (landed && count != null) setCartCount(count); };
        flyToCart(button, () => { landed = true; tick(); });
        setTimeout(() => syncDrawer((n) => { count = n; tick(); }), 32);
      } else {
        await syncDrawer();
        openDrawer();
      }
    } catch (err) {
      console.error(err);
      if (button) button.textContent = 'Try again';
      setTimeout(restore, 1500);
    } finally {
      if (button) { button.disabled = false; button.classList.remove('is-busy'); }
    }
  });

  /* ------------ Strength meter ------------ */
  const meter = $('[data-strength-meter]');
  if (meter) {
    const bar     = $('[data-meter-bar]', meter);
    const fill    = $('[data-meter-fill]', meter);
    const marker  = $('[data-meter-marker]', meter);
    const ticks   = $$('[data-meter-tick]', meter);
    const clearBtn= $('[data-meter-clear]', meter);
    const target  = meter.dataset.target || '/collections/all';

    const TIER_POSITIONS = { mild: 12.5, medium: 37.5, strong: 62.5, extra: 87.5 };
    const order = ['mild','medium','strong','extra'];

    const snapTo = (tier) => {
      const pct = TIER_POSITIONS[tier];
      fill.style.width  = pct + '%';
      marker.style.left = pct + '%';
      marker.setAttribute('aria-valuenow', order.indexOf(tier) + 1);
      ticks.forEach(t => t.classList.toggle('is-active', t.dataset.meterTick === tier));
    };

    const handlize = (s) => String(s).toLowerCase().trim()
      .replace(/['"`]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

    /* Ticks are server-rendered links to the tier's collection (or the
       tag-filtered catalog). Disabled tiers render as plain spans. */
    const urlFor = (tick) =>
      tick.getAttribute('href') ||
      target.replace(/\/$/, '') + '/' + handlize(tick.dataset.tierTag || tick.dataset.meterTick);

    const goTo = (tier) => {
      const tick = ticks.find(t => t.dataset.meterTick === tier);
      if (!tick || tick.classList.contains('is-disabled')) return;
      snapTo(tier);
      window.location.href = urlFor(tick);
    };

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        window.location.href = target;
      });
    }

    /* Drag-to-scrub - snaps to the 4 tier positions in real time,
       then opens that tier on release */
    let dragging = false;
    let lastIdx = -1;
    const pctFromX = (clientX) => {
      const rect = bar.getBoundingClientRect();
      return Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    };
    const idxFromPct = (pct) => Math.max(0, Math.min(3, Math.floor(pct / 25)));
    const onMove = (e) => {
      if (!dragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      const rawPct = pctFromX(x);
      const idx = idxFromPct(rawPct);
      if (idx === lastIdx) return;
      lastIdx = idx;
      const snapped = TIER_POSITIONS[order[idx]];
      fill.style.transition = 'width 140ms var(--bounce)';
      marker.style.transition = 'left 140ms var(--bounce)';
      fill.style.width  = snapped + '%';
      marker.style.left = snapped + '%';
      ticks.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    };
    const onUp = (e) => {
      if (!dragging) return;
      dragging = false;
      const idx = lastIdx;
      lastIdx = -1;
      if (idx >= 0) goTo(order[idx]);
    };
    const onDown = (e) => {
      dragging = true;
      lastIdx = -1;
      onMove(e); // a plain click on the bar selects the tier under the cursor
      e.preventDefault();
    };
    bar.addEventListener('mousedown', onDown);
    marker.addEventListener('mousedown', onDown);
    bar.addEventListener('touchstart', onDown, { passive: false });
    marker.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);

    /* Sync to URL tag on load - supports both /collections/x/<tag> and ?filter.p.tag= */
    const url = new URL(window.location.href);
    let tagParam = url.searchParams.get('filter.p.tag');
    if (!tagParam) {
      // Pick up the last path segment for /collections/<handle>/<tag>
      const segments = url.pathname.split('/').filter(Boolean);
      if (segments[0] === 'collections' && segments.length >= 3) {
        tagParam = decodeURIComponent(segments[2]);
      }
    }
    if (tagParam) {
      const wanted = handlize(tagParam);
      const found = ticks.find(t => handlize(t.dataset.tierTag || '') === wanted);
      if (found) {
        snapTo(found.dataset.meterTick);
        if (clearBtn) clearBtn.style.display = 'inline-flex';
      }
    }
  }

  /* ------------ Subscribe builder (real catalog data) ------------ */
  const subBuilder = $('[data-subscribe-builder]');
  if (subBuilder) {
    let subProducts = [];
    try { subProducts = JSON.parse($('[data-sub-products]', subBuilder).textContent || '[]'); } catch (e) { subProducts = []; }

    if (subProducts.length) {
      const subMoney = (cents) => '$' + (Number(cents) / 100).toFixed(2);
      const cleanTitle = (t) => (t || '').replace(/\s*Nicotine Pouches$/i, '');
      const firstAvailable = (p) => (p.variants || []).find(v => v.available) || (p.variants || [])[0] || null;
      // Cans per pack from the variant's pack label ("Single can" → 1, "5-pack" → 5).
      const packCans = (v) => {
        const m = String((v && v.pack) || '').match(/\d+/);
        return m ? parseInt(m[0], 10) : 1;
      };
      // Real % saved for a plan on a variant, from the allocation prices the
      // cart will actually charge; the plan's advertised pct is a fallback.
      const planPct = (pl, v) => {
        if (pl && v && v.alloc && v.alloc[pl.id] != null && v.price > 0) {
          const pct = Math.round((1 - v.alloc[pl.id] / v.price) * 100);
          if (pct > 0) return pct;
        }
        return pl && pl.pct ? Math.round(pl.pct) : 0;
      };

      const flavorBtns   = $$('[data-sub-index]', subBuilder);
      const packsWrap    = $('[data-sub-packs]', subBuilder);
      const cadGroup     = $('[data-sub-cadence-group]', subBuilder);
      const cadWrap      = $('[data-sub-cadences]', subBuilder);
      const variantInput = $('[data-sub-variant-input]', subBuilder);
      const planInput    = $('[data-sub-plan-input]', subBuilder);
      const addBtn       = $('[data-sub-add]', subBuilder);

      const sub = { product: null, variant: null, plan: null };

      const renderPacks = () => {
        packsWrap.innerHTML = '';
        (sub.product.variants || []).forEach(v => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sub-pack' + (sub.variant && v.id === sub.variant.id ? ' is-active' : '');
          if (!v.available) btn.disabled = true;
          const cans = packCans(v);
          const perCan = cans > 1 ? ', ' + subMoney(v.price / cans) + ' a can' : '';
          btn.innerHTML = '<span class="sub-pack__cans">' + v.pack + '</span>' +
                          '<span class="sub-pack__label">' + subMoney(v.price) + perCan + (v.available ? '' : ', sold out') + '</span>';
          btn.addEventListener('click', () => { sub.variant = v; renderPacks(); renderCard(); });
          packsWrap.appendChild(btn);
        });
      };

      const renderCadence = () => {
        const plans = sub.product.plans || [];
        if (!plans.length) { cadGroup.hidden = true; cadWrap.innerHTML = ''; return; }
        cadGroup.hidden = false;
        cadWrap.innerHTML = '';
        const addPill = (label, active, pct, onPick) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'opt-pill' + (active ? ' is-active' : '');
          btn.textContent = label;
          if (pct > 0) {
            const chip = document.createElement('span');
            chip.className = 'save';
            chip.textContent = pct + '% off';
            btn.appendChild(chip);
          }
          btn.addEventListener('click', () => { onPick(); renderCadence(); renderCard(); });
          cadWrap.appendChild(btn);
        };
        // Always offer a way out of the subscription - one-time at full price.
        addPill('One-time', !sub.plan, 0, () => { sub.plan = null; });
        const v = sub.variant || firstAvailable(sub.product);
        plans.forEach(pl => addPill(pl.name, sub.plan && pl.id === sub.plan.id, planPct(pl, v), () => { sub.plan = pl; }));
      };

      const setText = (sel, text) => { const el = $(sel, subBuilder); if (el) el.textContent = text; };

      const renderCard = () => {
        const v = sub.variant;
        const name = cleanTitle(sub.product.title);
        setText('[data-sub-summary]', name);
        setText('[data-sub-flavor-label]', name);
        setText('[data-sub-pack-label]', v ? v.pack : '');
        setText('[data-sub-cadence-label]', sub.plan ? sub.plan.name : 'One-time');

        let now = v ? v.price : 0, was = null, pct = null;
        if (sub.plan && v && v.alloc && v.alloc[sub.plan.id] != null) {
          was = v.price; now = v.alloc[sub.plan.id];
          pct = planPct(sub.plan, v);
        }
        setText('[data-sub-now]', subMoney(now));
        const wasEl = $('[data-sub-was]', subBuilder);
        if (wasEl) { if (was != null && was !== now) { wasEl.hidden = false; wasEl.textContent = subMoney(was); } else { wasEl.hidden = true; } }
        const saveWrap = $('[data-sub-save-wrap]', subBuilder);
        if (saveWrap) { if (pct) { saveWrap.hidden = false; setText('[data-sub-save-pct]', Math.round(pct)); } else { saveWrap.hidden = true; } }
        const cans = v ? packCans(v) : 1;
        setText('[data-sub-percan]', v ? (subMoney(now / cans) + ' per can') : '');
        const bogoOn = window.theme && window.theme.bogo && window.theme.bogo.active;
        setText('[data-sub-ships]', sub.plan ? ('Ships ' + sub.plan.name) : ('One-time purchase' + (bogoOn ? ', Buy 1 Get 1 applies' : '')));

        if (variantInput) variantInput.value = v ? v.id : '';
        if (planInput) {
          if (sub.plan) { planInput.value = sub.plan.id; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
        }
        if (addBtn) addBtn.disabled = !(v && v.available);
      };

      const selectProduct = (p) => {
        sub.product = p;
        sub.variant = firstAvailable(p);
        sub.plan = (p.plans && p.plans.length) ? p.plans[0] : null;
        renderPacks(); renderCadence(); renderCard();
      };

      flavorBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          flavorBtns.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          const idx = parseInt(btn.dataset.subIndex, 10);
          if (subProducts[idx]) selectProduct(subProducts[idx]);
        });
      });

      selectProduct(subProducts[0]);
    }
  }

  /* ------------ PDP sold out: Notify me button ------------ */
  // The link already jumps to the form; this also puts the cursor in the
  // email field. After a signup the field is gone and the plain jump shows
  // the "Noted" message instead.
  const bisJump = $('[data-bis-jump]');
  const bisEmail = $('#BisEmail');
  if (bisJump && bisEmail) {
    bisJump.addEventListener('click', (e) => {
      e.preventDefault();
      bisEmail.scrollIntoView({ block: 'center' });
      bisEmail.focus({ preventScroll: true });
    });
  }

  /* ------------ PDP variant + qty ------------ */
  const productForm = $('#ProductForm');
  if (productForm) {
    const variantInput = $('[data-variant-input]', productForm);
    const optionPills  = $$('[data-option-pills]', productForm);
    const priceEl      = $('[data-pdp-price]');
    const mainImg      = $('[data-pdp-main]');
    const heroAlt      = mainImg ? mainImg.alt : '';
    const qtyInput     = $('input[name="quantity"]', productForm);
    const submitBtn    = $('button[type="submit"]', productForm);

    // When a variant swaps the big image, light that photo's thumbnail and
    // take its alt; a photo with no thumbnail gets the first photo's alt.
    const fileOf = u => u.split('?')[0].split('/').pop();
    const followThumb = src => {
      const thumbs = $$('[data-thumb-index]');
      const hit = thumbs.find(t => { const im = t.querySelector('img'); return im && fileOf(im.src) === fileOf(src); });
      thumbs.forEach(t => t.classList.toggle('is-active', t === hit));
      mainImg.alt = hit ? hit.querySelector('img').alt : heroAlt;
    };

    // The big frame pads a can cut-out (a transparent PNG) and gives it a
    // shadow and a tilt; a photo with its own background fills the square
    // (is-photo). A JPEG always has one; another file has one when its
    // corners are opaque. The images come from the store's own /cdn/shop/
    // path, so the canvas can read them; if it can't, the frame stays padded.
    const heroBox = mainImg && mainImg.closest('[data-pdp-hero]');
    const hasBackground = img => {
      if (/\.jpe?g$/i.test(fileOf(img.currentSrc || img.src))) return true;
      try {
        const w = img.naturalWidth, h = img.naturalHeight;
        const x = Math.round(w * 0.02), y = Math.round(h * 0.02);
        const c = document.createElement('canvas');
        c.width = 5; c.height = 1;
        const ctx = c.getContext('2d');
        [[x, y], [w - 1 - x, y], [x, h - 1 - y], [w - 1 - x, h - 1 - y]]
          .forEach(([sx, sy], i) => ctx.drawImage(img, sx, sy, 1, 1, i, 0, 1, 1));
        const a = ctx.getImageData(0, 0, 5, 1).data;
        // The fifth pixel is never drawn: a browser that fakes canvas reads fills it.
        return a[19] === 0 && a[3] > 250 && a[7] > 250 && a[11] > 250 && a[15] > 250;
      } catch (e) {
        return false;
      }
    };
    const fitHero = img => { if (heroBox) heroBox.classList.toggle('is-photo', hasBackground(img)); };
    if (mainImg) {
      if (mainImg.complete) fitHero(mainImg);
      else mainImg.addEventListener('load', () => fitHero(mainImg), { once: true });
    }
    // The big image swaps once the new one has loaded, so the photo and its
    // frame change together; the last pick wins.
    let heroWanted = '';
    const showHero = src => {
      heroWanted = src;
      const next = new Image();
      next.onload = next.onerror = () => {
        if (heroWanted !== src) return;
        // The hero ships with a srcset, which outranks src - drop it or the swap won't show.
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        fitHero(next);
      };
      next.src = src;
    };

    const selectedOptions = () => {
      const arr = [];
      optionPills.forEach(group => {
        // A sale-size row can have no pill lit (a quantity no size matches);
        // every pill there is the same single can.
        const active = group.querySelector('.opt-pill.is-active') || group.querySelector('[data-sale-qty]');
        arr.push(active ? active.dataset.optionValue : '');
      });
      return arr;
    };

    const currentQty = () => Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    // The fewest cans the steppers go down to: the field's min, 1 on most
    // cans, the smallest deal size on a deal can (main-product.liquid).
    const qtyFloor = () => Math.max(1, parseInt(qtyInput && qtyInput.min, 10) || 1);

    /* Last-minute sale sizes (snippets/sale-packs.liquid): every size is the
       single can at a quantity, so a size sets the quantity, the steppers
       move off it, and the size that matches the quantity lights up. */
    const salePacks = $$('[data-sale-qty]', productForm);
    const syncSalePack = () => {
      if (!salePacks.length) return;
      const q = currentQty();
      const match = salePacks.find(p => !p.disabled && parseInt(p.dataset.saleQty, 10) === q);
      salePacks.forEach(p => p.classList.toggle('is-active', p === match));
      const valLabel = salePacks[0].closest('.opt-group').querySelector('[data-option-name]');
      if (valLabel) valLabel.textContent = match ? match.dataset.optionLabel : q + (q === 1 ? ' can' : ' cans');
    };

    /* Subscription plans - present when the product has selling plans.
       Allocation prices come from the Subscriptions app via the JSON blob
       in main-product.liquid, so what we display always matches what the
       cart and checkout charge. */
    let pdpPlans = [], pdpAlloc = {};
    const plansScript = $('[data-pdp-plans]');
    if (plansScript) {
      try {
        const data = JSON.parse(plansScript.textContent || '{}');
        pdpPlans = data.plans || [];
        pdpAlloc = data.alloc || {};
      } catch (e) { /* no plans - stays one-time only */ }
    }
    const purchase = { mode: 'onetime', plan: pdpPlans[0] || null };
    const planInput = $('[data-selling-plan]', productForm);
    const planGroup = $('[data-plan-group]', productForm);
    const planPills = $$('[data-plan-id]', productForm);
    const bogoNote  = $('.pdp__bogo-note', productForm);

    const baseUnitPrice = () => {
      const opt = variantInput.options[variantInput.selectedIndex];
      return opt ? parseInt(opt.dataset.variantPrice || '0', 10) : 0;
    };

    const currentUnitPrice = () => {
      if (purchase.mode === 'subscribe' && purchase.plan) {
        const alloc = pdpAlloc[variantInput.value];
        if (alloc && alloc[purchase.plan.id] != null) return alloc[purchase.plan.id];
      }
      return baseUnitPrice();
    };

    const refreshPrice = () => {
      const base = baseUnitPrice();
      const now = currentUnitPrice();
      if (priceEl) priceEl.textContent = money(now);
      const wasEl  = $('[data-pdp-was]');
      const chipEl = $('[data-pdp-save]');
      const saving = base > now;
      if (wasEl)  { wasEl.hidden = !saving; if (saving) wasEl.textContent = money(base); }
      if (chipEl) { chipEl.hidden = !saving; if (saving) chipEl.textContent = Math.round((base - now) * 100 / base) + '% off'; }
      const onetimePrice = $('[data-onetime-price]', productForm);
      if (onetimePrice) onetimePrice.textContent = money(base);
      // BOGO is a one-time-purchase promo - don't promise free packs on a subscription.
      if (bogoNote) bogoNote.hidden = purchase.mode === 'subscribe';
      refreshCtaPrice();
    };

    // Keep the "Add to bag $total" CTA in sync with unit price × quantity.
    // A Buy 1 Get 1 can (data-bogo) bought one-time pays for half its
    // quantity, rounded up: the discount frees one of each pair of the same
    // size, so 2 of this can cost one (the full total prints struck through).
    // A can already waiting in the bag can only make it cheaper.
    const bogoPdp = productForm.hasAttribute('data-bogo');
    const ctaTotal = () => {
      const unit = currentUnitPrice();
      const q = currentQty();
      if (bogoPdp && purchase.mode !== 'subscribe' && q > 1) {
        return '<s>' + money(unit * q) + '</s> ' + money(unit * (q - Math.floor(q / 2)));
      }
      return money(unit * q);
    };
    const refreshCtaPrice = () => {
      const ctaPrice = submitBtn && submitBtn.querySelector('[data-pdp-cta-price]');
      if (ctaPrice) ctaPrice.innerHTML = ctaTotal();
    };

    const syncVariant = () => {
      const wanted = selectedOptions().join('|');
      const opt = Array.from(variantInput.options).find(o => o.dataset.variantOptions === wanted);
      if (!opt) return;
      variantInput.value = opt.value;
      // A sale size is open only when the can's stock covers it.
      salePacks.forEach(p => {
        const stock = opt.dataset.variantStock;
        const ok = !opt.disabled && (stock == null || parseInt(p.dataset.saleQty, 10) <= parseInt(stock, 10));
        p.disabled = !ok;
        p.classList.toggle('is-unavailable', !ok);
      });
      // Fewer cans of this strength left than the smallest size: the last
      // ones go together, so the quantity and its floor become the stock.
      if (salePacks.length && qtyInput) {
        const first = Math.min(...salePacks.map(p => parseInt(p.dataset.saleQty, 10)));
        const stock = opt.disabled ? NaN : parseInt(opt.dataset.variantStock, 10);
        const last = stock > 0 && stock < first ? stock : 0;
        qtyInput.min = last || first;
        if (last || currentQty() < first) qtyInput.value = last || first;
        syncSalePack();
      }
      if (mainImg && opt.dataset.variantImage) {
        showHero(opt.dataset.variantImage);
        followThumb(opt.dataset.variantImage);
      }
      // Reflect real per-variant availability on the CTA so shoppers see
      // "Sold out" up front instead of a cryptic "Try again" on submit.
      if (submitBtn) {
        if (opt.disabled) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold out';
        } else {
          submitBtn.disabled = false;
          submitBtn.innerHTML = 'Add to bag <span class="btn__amt" data-pdp-cta-price>' + ctaTotal() + '</span>';
        }
      }
      refreshPrice();
    };

    optionPills.forEach(group => {
      $$('.opt-pill', group).forEach(pill => {
        pill.addEventListener('click', () => {
          $$('.opt-pill', group).forEach(p => p.classList.remove('is-active'));
          pill.classList.add('is-active');
          const valLabel = group.parentElement.querySelector('[data-option-name]');
          if (valLabel) valLabel.textContent = pill.dataset.optionLabel || pill.dataset.optionValue;
          if (pill.dataset.saleQty && qtyInput) qtyInput.value = pill.dataset.saleQty;
          syncVariant();
        });
      });
    });

    $('[data-qty-up]', productForm) && $('[data-qty-up]', productForm).addEventListener('click', () => {
      qtyInput.value = Math.max(qtyFloor(), parseInt(qtyInput.value || '1', 10) + 1);
      syncSalePack();
      refreshCtaPrice();
    });
    $('[data-qty-down]', productForm) && $('[data-qty-down]', productForm).addEventListener('click', () => {
      qtyInput.value = Math.max(qtyFloor(), parseInt(qtyInput.value || '1', 10) - 1);
      syncSalePack();
      refreshCtaPrice();
    });
    // Typing a quantity or using the number field's native steppers retotals too.
    qtyInput && qtyInput.addEventListener('input', () => { syncSalePack(); refreshCtaPrice(); });
    // After "Added" the button comes back as it was; the quantity may have moved since.
    productForm.addEventListener('ajax-add:restored', refreshCtaPrice);

    /* Thumbnail switcher */
    $$('[data-thumb-index]').forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb-index]').forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const img = thumb.querySelector('img');
        if (mainImg && img) {
          showHero(img.src.replace('width=200', 'width=900'));
          // The big image describes the photo it now shows (a lid, five cans...).
          mainImg.alt = img.alt;
        }
      });
    });

    /* One-time vs subscribe toggle + delivery cadence pills */
    const setPurchaseMode = (mode) => {
      purchase.mode = mode;
      $$('.sub-toggle button', productForm).forEach(b => b.classList.toggle('is-active', b.dataset.subMode === mode));
      if (planGroup) planGroup.hidden = mode !== 'subscribe';
      if (planInput) {
        if (mode === 'subscribe' && purchase.plan) {
          planInput.value = purchase.plan.id;
          planInput.disabled = false;
        } else {
          // Disabled keeps the field out of the form data - /cart/add.js
          // keys off its presence.
          planInput.value = '';
          planInput.disabled = true;
        }
      }
      const planLabel = $('[data-plan-label]', productForm);
      if (planLabel) planLabel.textContent = (mode === 'subscribe' && purchase.plan) ? purchase.plan.name : '';
      refreshPrice();
    };
    $$('.sub-toggle button', productForm).forEach(btn => {
      btn.addEventListener('click', () => setPurchaseMode(btn.dataset.subMode));
    });
    planPills.forEach(pill => {
      pill.addEventListener('click', () => {
        purchase.plan = pdpPlans.find(p => String(p.id) === String(pill.dataset.planId)) || purchase.plan;
        planPills.forEach(p => p.classList.toggle('is-active', p === pill));
        setPurchaseMode('subscribe');
      });
    });
  }

  /* ------------ Collection filters ------------ */
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    let timer;
    filterForm.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const params = new URLSearchParams(new FormData(filterForm));
        const sortBy = $('[data-sort-by]');
        if (sortBy && sortBy.value) params.set('sort_by', sortBy.value);
        // Strip blank values
        for (const [k, v] of Array.from(params.entries())) { if (!v) params.delete(k); }
        const url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
        window.location.href = url;
      }, 350);
    });

    const sortBy = $('[data-sort-by]');
    if (sortBy) {
      sortBy.addEventListener('change', () => {
        const params = new URLSearchParams(new FormData(filterForm));
        params.set('sort_by', sortBy.value);
        for (const [k, v] of Array.from(params.entries())) { if (!v) params.delete(k); }
        window.location.href = window.location.pathname + '?' + params.toString();
      });
    }
  }

  /* Mobile filter drawer */
  const filterSidebar = $('[data-filter-sidebar]');
  const filterOverlay = $('[data-filter-overlay]');
  if (filterSidebar) {
    $('[data-filter-open]') && $('[data-filter-open]').addEventListener('click', () => {
      filterSidebar.classList.add('is-open');
      filterOverlay && filterOverlay.classList.add('is-open');
    });
    $('[data-filter-close]') && $('[data-filter-close]').addEventListener('click', () => {
      filterSidebar.classList.remove('is-open');
      filterOverlay && filterOverlay.classList.remove('is-open');
    });
    filterOverlay && filterOverlay.addEventListener('click', () => {
      filterSidebar.classList.remove('is-open');
      filterOverlay.classList.remove('is-open');
    });
  }

  /* ------------ Last-minute sale countdowns ------------ */
  // sections/last-minute-sale.liquid prints its deadlines as epochs worked out in
  // store time, so every shopper counts down to the same moment: the whole
  // sale's on the band (data-ends) and each can's on its card (data-ends, from
  // its Deal block or its best-before date). A can whose time is up leaves the
  // band; with no sale-wide time (data-lms-next) the big clock moves on to the
  // next can to go. The band hides once the sale is over, or once every can has
  // gone and there is no banner. In the theme editor nothing hides; it shows as
  // over instead, so it can still be edited.
  const lmsPad = (n) => (n < 10 ? '0' : '') + n;
  const lmsShort = (s) => s >= 86400
    ? Math.floor(s / 86400) + 'd ' + lmsPad(Math.floor(s % 86400 / 3600)) + 'h ' + lmsPad(Math.floor(s % 3600 / 60)) + 'm'
    : lmsPad(Math.floor(s / 3600)) + 'h ' + lmsPad(Math.floor(s % 3600 / 60)) + 'm ' + lmsPad(s % 60) + 's';
  const initSaleBand = (band) => {
    if (band.dataset.lmsReady) return;
    band.dataset.lmsReady = '1';
    const editing = !!(window.Shopify && window.Shopify.designMode);
    const saleEnds = (parseInt(band.dataset.ends, 10) || 0) * 1000;
    const followNext = band.hasAttribute('data-lms-next');
    const timer = $('[data-lms-timer]', band);
    const endsLabel = $('[data-lms-ends]', band);
    const units = {};
    $$('[data-lms-unit]', band).forEach(el => { units[el.dataset.lmsUnit] = el; });
    const allCards = $$('.lms__grid .product', band);
    const cards = $$('[data-lms-card]', band).map(el => ({
      el, ends: (parseInt(el.dataset.ends, 10) || 0) * 1000, label: el.dataset.endsLabel || '',
      clock: $('[data-lms-clock]', el), pill: $('.product__clock', el), done: el.classList.contains('is-over')
    }));
    const hasBanner = !!$('.lms__banner', band);
    let gone = 0;
    let shownNext = 0;
    // Returns false once no clock is left to tick.
    const tick = () => {
      if (!band.isConnected) return false;
      const now = Date.now();
      if (saleEnds && now >= saleEnds) {
        if (band.hasAttribute('data-hide-when-over') && !editing) band.hidden = true;
        else band.classList.add('is-over');
        return false;
      }
      let next = null;
      cards.forEach(c => {
        if (!c.ends || c.done) return;
        const left = Math.floor((c.ends - now) / 1000);
        if (left <= 0) {
          c.done = true;
          if (editing) {
            c.el.classList.add('is-over');
            if (c.pill) c.pill.textContent = 'Ended';
          } else {
            c.el.hidden = true;
            gone++;
          }
          return;
        }
        // Only a can showing its own clock (its last few days) can lead the big one.
        if (!c.clock) return;
        c.clock.textContent = lmsShort(left);
        if (!next || c.ends < next.ends) next = c;
      });
      if (!editing && !hasBanner && allCards.length && gone === allCards.length) {
        band.hidden = true;
        return false;
      }
      const target = saleEnds || (followNext && next ? next.ends : 0);
      if (timer) {
        timer.hidden = !target;
        if (target) {
          if (followNext && next.ends !== shownNext) {
            shownNext = next.ends;
            if (endsLabel && next.label) endsLabel.textContent = next.label;
          }
          let left = Math.floor((target - now) / 1000);
          const d = Math.floor(left / 86400); left %= 86400;
          const h = Math.floor(left / 3600);  left %= 3600;
          const m = Math.floor(left / 60);
          if (units.d) units.d.textContent = lmsPad(d);
          if (units.h) units.h.textContent = lmsPad(h);
          if (units.m) units.m.textContent = lmsPad(m);
          if (units.s) units.s.textContent = lmsPad(left % 60);
        }
      }
      return !!(saleEnds || next);
    };
    if (tick()) {
      const id = setInterval(() => { if (!tick()) clearInterval(id); }, 1000);
    }
  };
  $$('[data-lms]').forEach(initSaleBand);
  // The theme editor re-renders a section on every setting change.
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-lms]', e.target).forEach(initSaleBand);
  });

  /* ------------ Hero: posters (sections/hero-posters.liquid) ------------ */
  // Copy, numeral, can and the colorbar rotate together. Autoplay waits on a
  // pointer over the hero, keyboard focus inside it, the Pause button, a hidden
  // tab and a visitor who asks for less motion; the theme editor jumps to the
  // poster being edited and holds there.
  const initPosterHero = (hero) => {
    if (hero.dataset.posterReady) return;
    hero.dataset.posterReady = '1';
    const slides = $$('.hero__slide', hero);
    const scenes = $$('[data-poster-scene]', hero);
    const tabs = $$('.hero__tab', hero);
    const pauseBtn = $('.hero__pause', hero);
    const slidesEl = $('.hero__slides', hero);
    const colorbar = $('.colorbar', hero);
    const bars = colorbar ? $$('.colorbar__band', colorbar) : [];
    const sweep = colorbar ? $('.colorbar__sweep', colorbar) : null;
    const interval = parseInt(hero.dataset.interval, 10) || 6000;
    const editing = !!(window.Shopify && window.Shopify.designMode);
    let i = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    let timer = null, startedAt = 0, remaining = interval;
    let hovering = false, focused = false, userPaused = hero.hasAttribute('data-no-autoplay');
    hero.style.setProperty('--slide-ms', interval + 'ms');

    const autoplay = () => !reducedMotion() && !userPaused && !hovering && !focused && !document.hidden && slides.length > 1;
    const halt = () => {
      if (timer) { clearTimeout(timer); timer = null; }
      if (startedAt) { remaining = Math.max(0, remaining - (Date.now() - startedAt)); startedAt = 0; }
    };
    const run = () => {
      startedAt = Date.now();
      timer = setTimeout(() => { timer = null; startedAt = 0; show(i + 1); }, remaining);
    };
    const sync = () => {
      const on = autoplay();
      hero.classList.toggle('is-paused', !on);
      if (on && !timer) run();
      if (!on && timer) halt();
    };
    const restart = (el) => { el.style.animation = 'none'; void el.offsetWidth; el.style.animation = ''; };
    const resetClocks = () => {
      tabs.forEach(t => { const bar = t.querySelector('i'); if (bar) restart(bar); });
      if (sweep) restart(sweep);
    };
    // The strip takes the active can's colors; on a change the bands step in with the can.
    const paintBars = (k, ripple) => {
      const pal = ((scenes[k] && scenes[k].dataset.palette) || '').split(',');
      bars.forEach((b, j) => { if (pal[j]) b.style.setProperty('--c', pal[j].trim()); });
      if (ripple && colorbar) { colorbar.classList.remove('is-rippling'); void colorbar.offsetWidth; colorbar.classList.add('is-rippling'); }
    };
    const setPaused = (on) => {
      userPaused = on;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', String(on));
        pauseBtn.setAttribute('aria-label', on ? 'Play posters' : 'Pause posters');
      }
    };
    function show(n) {
      halt();
      remaining = interval;
      const prev = slides[i];
      i = (n + slides.length) % slides.length;
      const next = slides[i];
      if (prev !== next) {
        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        setTimeout(() => prev.classList.remove('is-leaving'), 400);
      }
      next.classList.add('is-active');
      scenes.forEach((s, k) => s.classList.toggle('is-active', k === i));
      paintBars(i, true);
      hero.dataset.style = next.dataset.style || 'magenta';
      tabs.forEach((t, k) => {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      resetClocks();
      sync();
    }

    tabs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    if (pauseBtn) pauseBtn.addEventListener('click', () => { setPaused(!userPaused); sync(); });
    hero.addEventListener('mouseenter', () => { hovering = true; sync(); });
    hero.addEventListener('mouseleave', () => { hovering = false; sync(); });
    // Keyboard focus holds the rotation; a click on a tab does not.
    hero.addEventListener('focusin', (e) => { focused = e.target.matches(':focus-visible'); sync(); });
    hero.addEventListener('focusout', (e) => { if (!hero.contains(e.relatedTarget)) { focused = false; sync(); } });
    document.addEventListener('visibilitychange', sync);
    hero.addEventListener('keydown', (e) => {
      if (!e.target.closest('.hero__tabs')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); tabs[i].focus(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); tabs[i].focus(); }
    });
    let touchX = null;
    const swipeFrom = (el) => {
      if (!el) return;
      el.addEventListener('touchstart', (e) => { touchX = e.changedTouches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', (e) => {
        if (touchX === null) return;
        const dx = e.changedTouches[0].clientX - touchX; touchX = null;
        if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      }, { passive: true });
    };
    swipeFrom(slidesEl);
    swipeFrom($('.hero__poster', hero));
    if (editing) {
      // The editor selects a block: show that poster and hold it there.
      document.addEventListener('shopify:block:select', (e) => {
        const el = e.target && e.target.closest ? e.target.closest('[data-poster-index]') : null;
        if (!el || !hero.contains(el)) return;
        setPaused(true);
        show(parseInt(el.dataset.posterIndex, 10) || 0);
      });
    }

    if (userPaused && pauseBtn) setPaused(true);
    paintBars(i, false);
    resetClocks();
    sync();
  };
  $$('[data-hero-rotate]').forEach(initPosterHero);
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-hero-rotate]', e.target).forEach(initPosterHero);
  });

  /* ------------ Cart page qty ------------ */
  $$('[data-cart-qty]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.lineKey;
      const item = document.querySelector(`[data-cart-item="${CSS.escape(key)}"]`);
      if (!item) return;
      const span = item.querySelector('.line__qty span');
      // The row's first line moves (data-line-head-qty); the span shows the row's total.
      let q = headQty(item, span);
      q = btn.dataset.cartQty === '+' ? q + 1 : Math.max(0, q - 1);
      await changeLine(key, q);
      window.location.reload();
    });
  });
  // Remove clears every line of the row; the link's own href clears one line without the script.
  $$('.cart-page [data-line-remove]').forEach(a => {
    a.addEventListener('click', async (e) => {
      e.preventDefault();
      await removeRow(a);
      window.location.reload();
    });
  });
})();
